function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

import { buildComponentName } from '../utils';
import Dropdown from './dropdown';
import Button from '../button';
var dropdownPropKeys = Dropdown.props;
export default {
  name: buildComponentName('DropdownButton'),
  model: {
    prop: 'visible'
  },
  props: _objectSpread({}, dropdownPropKeys, {}, Button.Group.props, {
    prefixCls: {
      type: String,
      default: 'ux-dropdown-button'
    },
    placement: {
      type: String,
      default: 'bottomRight'
    },
    type: {
      type: String,
      default: '',
      validator: function validator(val) {
        return ['', 'primary', 'ghost', 'dashed', 'danger'].indexOf(val) > -1;
      }
    }
  }),
  computed: {
    bindDropdownProps: function bindDropdownProps() {
      var $props = this.$props;
      return _objectSpread({}, $props, {
        prefixCls: 'ux-dropdown'
      });
    }
  },
  methods: {
    onInput: function onInput() {
      for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
        args[_key] = arguments[_key];
      }

      this.$emit.apply(this, ['input'].concat(args));
    },
    onOverlayClick: function onOverlayClick() {
      for (var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
        args[_key2] = arguments[_key2];
      }

      this.$emit.apply(this, ['overlay-click'].concat(args));
    },
    onVisibleChange: function onVisibleChange() {
      for (var _len3 = arguments.length, args = new Array(_len3), _key3 = 0; _key3 < _len3; _key3++) {
        args[_key3] = arguments[_key3];
      }

      this.$emit.apply(this, ['visible-change'].concat(args));
    },
    onClick: function onClick(e) {
      this.$emit('click', e);
    }
  },
  render: function render() {
    var h = arguments[0];
    var $slots = this.$slots,
        bindDropdownProps = this.bindDropdownProps,
        size = this.size,
        type = this.type,
        disabled = this.disabled,
        onClick = this.onClick,
        onInput = this.onInput,
        onOverlayClick = this.onOverlayClick,
        onVisibleChange = this.onVisibleChange; // const dropdownProps = Object.keys($props || {}).reduce((r, k) => {
    //   const nr = r;
    //   if (k in dropdownPropKeys) {
    //     nr[k] = $props[k];
    //   }
    //   return nr;
    // }, {});

    var on = {
      input: onInput,
      'overlay-click': onOverlayClick,
      'visible-change': onVisibleChange
    };
    return h(Button.Group, {
      "attrs": {
        "size": size
      }
    }, [h(Button, {
      "attrs": {
        "type": type,
        "disabled": disabled
      },
      "on": {
        "click": onClick
      }
    }, [$slots.default]), h(Dropdown, {
      "props": _objectSpread({}, bindDropdownProps),
      "on": _objectSpread({}, on)
    }, [h(Button, {
      "slot": "trigger",
      "attrs": {
        "type": type,
        "icon": "more"
      }
    }), h("template", {
      "slot": "overlay"
    }, [$slots.overlay])])]);
  }
};